// Inspired by Google Closure:
// http://closure-library.googlecode.com/svn/docs/
// closure_goog_array_array.js.html#goog.array.clear
/*es5-ext/array/#/clear*/
function _(require, module, exports) {
    var value = require(306    /* ../../object/valid-value */);
    module.exports = function () {
        value(this).length = 0;
        return this;
    };
}